export default function AufgabeButton({rowEntry, instance, reload}) {

    const changeState = event => {
        event.preventDefault();
        let taskId = event.target.id;
        let taskState = event.target.value;

        console.log("id", taskId);
        console.log("state", taskState);

        // TODO:schauen ob die Route so laufen mag
        instance.patchNewState(taskId, taskState, (error, data, response) => {
            if (error) {
                console.log(error);
            } else {
                console.log("klappt");
                reload();
            }
        })
    }

    return (
        <>
        <button 
            onClick={changeState} 
            id={rowEntry.id_aufgabe}
            value={rowEntry.erledigt}>
                {rowEntry.erledigt ? "wieder öffnen" : "als erledigt kennzeichnen"}
        </button>
        </>
    )
}